import { useEffect, useCallback } from 'react';
// @mui
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
// routes
import { paths } from 'src/routes/paths';
import { useParams } from 'src/routes/hook';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import EmptyContent from 'src/components/empty-content';
// types
import { HTBaiViet } from 'src/types/htblog';
// sections
import BlogNewEditForm from '../blog-new-edit-form';
// hooks (local)
import useBlog from '../hooks/use-blog';

// ----------------------------------------------------------------------

export default function BlogEditView() {
  const settings = useSettingsContext();
  const params = useParams();
  const { id } = params;

  const { blog, blogStatus, getBlog } = useBlog();

  const fetchBlog = useCallback(async () => {
    if (!id) return;
    try {
      await getBlog(Number(id));
    } catch (error) {
      console.error('Error fetching blog:', error);
    }
  }, [id, getBlog]);

  useEffect(() => {
    fetchBlog();
  }, [fetchBlog]);

  if (blogStatus.loading) {
    return (
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (!blog) {
    return (
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <EmptyContent
          filled
          title="Không tìm thấy bài viết"
          sx={{ py: 10 }}
        />
      </Container>
    );
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Chỉnh sửa bài viết"
        links={[
          {
            name: 'Dashboard',
            href: paths.dashboard.root,
          },
          {
            name: 'Blog',
            href: paths.dashboard.blog.root,
          },
          { name: blog?.tieuDe || '' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <BlogNewEditForm currentBlog={blog as HTBaiViet} />
    </Container>
  );
}